import { useCallback, useEffect, useState } from 'react';
import { CustomerInvitationListResponseDto } from '../../../lib/interfaces/customers/users';
import { Paginated, Pagination } from '../../../lib/interfaces/utils';
import useApiRequest from '../../../lib/hooks/useRequest';
import DataFetchParent from '../../../ui/components/ui/data-fetch';
import { InvitationDataTable } from './invitation-data-table';
import { useSearchParams } from 'react-router-dom';

const CustomerInvitedFetch = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [initLoading, setInitLoading] = useState(true);
  const [customers, setCustomers] = useState<CustomerInvitationListResponseDto[]>();
  const [reload, setReload] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  const [searchParams, setSearchParams] = useSearchParams();

  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: searchParams.get('page') ? parseInt(searchParams.get('page')!) - 1 : 0,
    pageSize: 10
  });

  useEffect(() => {
    setSearchParams((params) => {
      const newParams = new URLSearchParams(params);
      newParams.set('page', (pagination.pageIndex + 1).toString());
      return newParams;
    });
  }, [pagination.pageIndex, setSearchParams]);

  const { apiRequest } = useApiRequest();

  const getCustomersPaginated = useCallback(async () => {
    let url = `users/customer/invitations?limit=${pagination.pageSize}&page=${pagination.pageIndex + 1}`;
    setIsLoading(true);
    const res = await apiRequest<Paginated<CustomerInvitationListResponseDto>>(url, 'GET');
    setInitLoading(false);
    setIsLoading(false);
    if (res.data) {
      setCustomers(res.data.docs);
      setPageCount(Math.ceil(res.data.count / pagination.pageSize));
      setPageCount(res.data.pageCount);
    }
  }, [apiRequest, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    getCustomersPaginated();
  }, [pagination, getCustomersPaginated, reload]);

  return (
    <>
      <DataFetchParent
        isLoading={initLoading}
        data={customers}
        renderElement={() => (
          <InvitationDataTable
            data={customers ?? []}
            setReload={setReload}
            setPagination={setPagination}
            pageCount={pageCount}
            pagination={pagination}
            isLoading={isLoading}
          />
        )}
      />
    </>
  );
};

export default CustomerInvitedFetch;
